import { useFlags } from 'launchdarkly-react-client-sdk';
import { useAppSelector } from 'src/hooks/store';
import { selectedWarehouseIdSelector } from 'src/state/selectors/delivery';
import { isWarehouseFlagEnabled } from 'src/utils/warehouseFlag';

// deliveryServiceOutboundGates is a warehouse-array flag. Returns undefined
// while LaunchDarkly is still loading, so callers that redirect can tell "off"
// apart from "not known yet".
export const useOutboundGatesEnabled = (): boolean | undefined => {
  const { deliveryServiceOutboundGates } = useFlags();
  const selectedWarehouseId = useAppSelector(selectedWarehouseIdSelector);

  if (deliveryServiceOutboundGates === undefined) return undefined;
  return isWarehouseFlagEnabled(
    deliveryServiceOutboundGates,
    selectedWarehouseId,
  );
};
